import { createFileRoute } from "@tanstack/react-router";

import { CampaignReport } from "@/components/campanhas/CampaignReport";
import { CampaignManager } from "@/components/revendedor/CampaignManager";
import {
  queryToSearch,
  searchToQuery,
  validateCampaignSearch,
  type CampaignSearch,
} from "@/lib/campaigns";
import { presetPeriod } from "@/lib/reports";
import { useResellerMe } from "@/lib/resellers";

export const Route = createFileRoute("/revendedor/_area/campanhas/")({
  validateSearch: validateCampaignSearch,
  head: () => ({ meta: [{ title: "Campanhas — Revenda MonteBox" }] }),
  component: ResellerCampaigns,
});

/**
 * Campanhas: os links de divulgação e o resultado de cada um.
 *
 * Em cima, o que se faz (criar, copiar, arquivar); embaixo, o que deu
 * (funil e tabela). Filtros na URL, como nos relatórios do painel.
 */
function ResellerCampaigns() {
  const me = useResellerMe();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const filters = searchToQuery(search, presetPeriod("30d"));

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-mb-navy">Campanhas</h1>
        <p className="mt-1 text-sm text-mb-muted">
          Crie um link para cada lugar em que você divulga e veja qual traz mais clientes.
        </p>
      </div>

      {me.data && <CampaignManager code={me.data.code} />}

      <div>
        <h2 className="font-display text-lg font-bold text-mb-navy">Resultados</h2>
        <p className="mt-1 text-xs text-mb-muted">
          Venda de cliente que você já trouxe conta para a campanha que o trouxe, mesmo meses
          depois. Toque numa campanha para ver o funil dela.
        </p>
      </div>
      <CampaignReport
        side="reseller"
        filters={filters}
        onChange={(next) => void navigate({ search: queryToSearch(next) as CampaignSearch })}
        onOpen={(campanhaId) =>
          void navigate({
            to: "/revendedor/campanhas/$campanhaId",
            params: { campanhaId },
            search: { de: filters.from, ate: filters.to },
          })
        }
      />
    </div>
  );
}
